"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aideLastVisitPayloadToFormDataHandler = aideLastVisitPayloadToFormDataHandler;
function aideLastVisitPayloadToFormDataHandler(data) {
    return {
        visitDate: data.form.visitDate,
        notes: data.form.notes || "",
    };
}
